import React, { useState, useEffect, useRef } from "react";
import { Helmet } from "react-helmet-async";
import { Home } from "lucide-react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import { Phone, Mail, MapPin } from "lucide-react";
import { } from "lucide-react";
import bannerImg from "../assets/images/contactbannernew.webp";
import Spinner from "react-activity/dist/Spinner";
import "react-activity/dist/Spinner.css";
import Swal from 'sweetalert2';
import axios from "axios";
import { apiUrl } from "../config/Config";
import { FaWhatsapp } from "react-icons/fa";
import AOS from "aos";


import {
  faPhone,
  faEnvelope,
  faLocationDot
} from "@fortawesome/free-solid-svg-icons";
const Contact = () => {
  const [name, setname] = useState("");
  const [email, setemail] = useState("");
  const [number, setnumber] = useState("");
  const [message, setmessage] = useState("");
  const [isloading, setisloading] = useState("");

  const handlesubmit = async() => {
    if(name && number && message) {
      setisloading(true);
      var data = {
        name: name,
        email: email,
        number: number,
        message: message
      }
      const headers = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      let resp = await axios
        .post(apiUrl + "submitcontactform", data, headers)
        .then((res) => {
          // console.log('res >>>', res.data)
          if (res.data.status == "success") {
            Swal.fire({
              title: '',
              text: 'Thank you for your enquiry. Our team will respond shortly.',
              icon: 'success',
              customClass: {
                icon: 'custom-swal-icon' // Apply the custom class
              },
              width: '350px',
              confirmButtonText: 'Ok',
          confirmButtonColor: "rgb(59, 151, 196)",
              customClass: {
                  popup: "small-icon-alert",
                },
            });
            setname("");
            setemail("");
            setnumber("");
            setmessage("");
            // window.location.reload();
            setisloading(false);
          } else {
                Swal.fire({
                  title: '',
                  text: res.data.message,
                  icon: 'error',
                  customClass: {
                    icon: 'custom-swal-icon' // Apply the custom class
                  },
                  width: '350px',
                  confirmButtonText: 'Ok',
              confirmButtonColor: "rgb(59, 151, 196)",
                  customClass: {
                      popup: "small-icon-alert",
                    },
                });
            setisloading(false);
          }
        })
        .catch((err) => {
          setisloading(false);
          alert(err.message);
        });
    } else {
      Swal.fire({
        title: "",
        text: "Mandatory Fields cannot be empty.",
        icon: "error",
        customClass: {
          icon: "custom-swal-icon", // Apply the custom class
        },
        width: "350px",
        confirmButtonText: "Ok",
        confirmButtonColor: "rgb(59, 151, 196)",
        customClass: {
          popup: "small-icon-alert",
        },
      });
    }
  }

  useEffect(() => {
    AOS.init({
     
    });
  }, []);
    return (
<>
<Helmet>
        {/* Meta Title */}
        <title>Contact TheOmSaga</title>

        {/* Meta Description */}
        <meta
          name="description"
          content="Reach out to TheOmSaga to share your inspirational spiritual stories, collaborate on spiritual tales or ask any questions about our storytelling platform."
        />

        {/* Primary Keywords */}
        <meta
          name="keywords"
          content="spiritual stories, spiritual tale, spiritual story telling platform"
        />

        {/* Canonical Tag (FIXED) */}
        <link rel="canonical" href="https://theomsaga.com/contactus" />

        {/* Open Graph Tags */}
        <meta property="og:title" content="Contact TheOmSaga" />
        <meta
          property="og:description"
          content="Reach out to TheOmSaga to share your inspirational spiritual stories, collaborate on spiritual tales or ask any questions about our storytelling platform."
        />
        <meta property="og:url" content="https://theomsaga.com/contactus" />
        <meta
          property="og:image"
          content="https://theomsaga.com/assets/images/contact-banner.webp"
        />

        {/* Schema Markup */}
        <script type="application/ld+json">
          {`
          {
            "@context": "https://schema.org",
            "@type": "ContactPage",
            "@id": "https://theomsaga.com/contactus#contactpage",
            "name": "Contact TheOmSaga",
            "url": "https://theomsaga.com/contactus",
            "description": "Contact TheOmSaga to share spiritual stories, collaborate on faith-based storytelling, or reach out with questions about our spiritual storytelling platform.",
          "sameAs": [
                  "https://www.instagram.com/theomsaga20?igsh=MWNnN3E0NGVleTltZw==",
                  "https://www.facebook.com/share/1B44vEtGc7/"
                ]
         
            }
          `}
        </script>
      </Helmet>


      <div>
           <section className="home-main-sec ">

        <img src={bannerImg} className="home-main-sec-bg" alt="Banner" />

        <div className="home-main-sec-overlay"></div>

        <div className="container home-main-sec-content">

          <h1 className="loop-title">
          Get in Touch to Seek, Share, or Support
          </h1>



        </div>

      </section>



      <section className="contact-page-section">
      <div className=" container contact-page-container ">

        {/* LEFT FORM */}
        <div className="contact-page-form-box"  data-aos="fade-up" data-aos-delay="200" data-aos-duration="1000">
          <h2 className="contact-page-title">Leave a Reply</h2>
          <p className="contact-page-subtitle">
            Fill out the form, and we will get back to you as soon as possible.
          </p>

          <form className="contact-page-form" onSubmit={(e) => {e.preventDefault()}}>
            <input
              value={name}
              onChange={(e) => {
                const onlyText = e.target.value.replace(/[^a-zA-Z\s]/g, "");
                setname(onlyText)
              }
               
              }
              type="text"
              placeholder="Your Name *" 
              className="contact-page-input"
            />

            <input
            value={email}
            onChange={(e) =>
              setemail(e.target.value)
            }
              type="email"
              placeholder="Your Email "
              className="contact-page-input"
            />

            <input
            value={number}
            onChange={(e) => {
              const onlyNumbers = e.target.value.replace(/[^0-9]/g, '');
              setnumber(onlyNumbers);
            }
            }
            maxLength={10}
              type="tel"
              placeholder="Your Phone Number *"
              className="contact-page-input"
            />

            <textarea
            value={message}
            onChange={(e) => {
              setmessage(e.target.value);
            }
            }
              placeholder="Write here...."
              className="contact-page-textarea"
            ></textarea>


            <button type="submit" className="contact-page-btn" onClick={() => {
              if(isloading) {

              } else {
                handlesubmit();
              }
              
              
              }}>
              {
                isloading ?
                <Spinner color="#fff" size={15} className="spinnerCenter" /> : "Submit"
              }
            </button>
          </form>
        </div>

        {/* RIGHT INFO */}
        <div className="contact-page-info-box"  data-aos="fade-up" data-aos-delay="200" data-aos-duration="1000">
          <h2 className="contact-page-info-title">Support & Suggestions</h2>
          <p className="contact-page-info-subtitle">
      If you have any queries, questions, or need further clarification, please feel free to contact us. We are always here to assist you and provide the information you need.
          </p>

          <div className="contact-page-info-item">
            <div className="contact-page-icon">
            {/* <FontAwesomeIcon icon={faPhone} /> */}
         <FaWhatsapp />
            </div>
            <div>
              <p>For Queries</p>
              <span>+91 8197571882</span>
              <br />
         
            </div>
          </div>

          <hr className="contact-page-divider" />

          <div className="contact-page-info-item">
            <div className="contact-page-icon">
            <FontAwesomeIcon icon={faEnvelope} />
            </div>
            <div>
              <p>Email</p>
              <span>info@theomsaga.com</span> 
          
              <br />
            
            </div>
          </div>

          {/* <hr className="contact-page-divider" />

          <div className="contact-page-info-item">
            <div className="contact-page-icon contact-page-icon-location-address  ">
            <FontAwesomeIcon icon={faLocationDot} />
            </div>
            <div>
              <p>Regional Office</p>
              <span>
              Bengaluru, Karnataka – 560038, India
              </span>
            </div>
          </div> */}
        </div>

      </div>
    </section>











{/* 
          <section className="">
                <div className="container text-center">
                    
                    <div className="contact-mid-section">
                        <div className="row">
                            <div className="col-12 col-md-6 col-lg-6 mb-4">
                                <div className="contact-box   " data-aos="fade-up" data-aos-delay="300" data-aos-duration="500"  >
                                    
                                    <div className="contact-box-content">
                                        <FontAwesomeIcon icon={faWhatsapp}   style={{ color: "#25D366", fontSize: "22px" }} className="contact-icon"/>
                                        <p className="contact-box-content-tittle">
                                       whatsapp number
                                        </p>

                                        <p className="contact-box-content-number">+91 8197571882</p>
                                    </div>
                                </div>
                            </div>

                            <div className="col-12 col-md-6 col-lg-6 mb-4">
                                <div className="contact-box   " data-aos="fade-up" data-aos-delay="300" data-aos-duration="500"  >
                                    
                                    <div className="contact-box-content">
                                         <Mail className="contact-icon"  size={48}/> 
                                        <p className="contact-box-content-tittle">
                                          e-mail
                                        </p>

                                        <p className="contact-box-content-number">theomsaga@gmail.com</p>
                                    </div>
                                </div>
                            </div>

                           <div className="col-12 col-md-6 col-lg-4 mb-4">
                                <div className="contact-box   " data-aos="fade-up" data-aos-delay="300" data-aos-duration="500"  >
                                    
                                    <div className="contact-box-content">
                                         <MapPin className="contact-icon"  size={48}/> 
                                        <p className="contact-box-content-tittle">
                                         Address
                                        </p>

                                        <p className="contact-box-content-number">123, A Street B Block Dewas,<br />
M.P. #455001</p>
                                    </div>
                                </div>
                            </div> 
                           
                        </div>
                    </div>
                </div>
            </section> */}
        </div>
</>


       
    )
}

export default Contact